import api from "../api";

export const useAdminUpadteWithdraw = (data) =>
  api.put(`/withdraw`, data).then((res) => res.data);
